import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useEffect, useState } from 'react';

require('highcharts/modules/exporting')(Highcharts);


export function PieChart({ name, data }) {
  const [options, setOptions] = useState({});

  useEffect(() => {
    let options = {
      chart: { type: 'pie' },
      title: { text: name },
      series: [{ data: data }],
      credits: {
        enabled: false
      },
      tooltip: {
        pointFormatter: function () {
          return "Experiments: " + this.y
        }
      }
    };

    setOptions(options);
  }, [])

  return (
    <div className="pie-chart">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  )
}